<template>
  <v-dialog
    persistent
    v-model="visible"
    scrollable
    :fullscreen="isMobile"
    :max-width="isMobile ? '480px' : '440px'"
    :content-class="isMobile ? 'reimbursement-fee isMobile' : 'reimbursement-fee'"
    :transition="isMobile ? 'dialog-bottom-transition' : 'dialog-transition'"
  >
    <template v-slot:activator="{ on }">
      <v-card
        flat
        color="#EFF3FE"
        class="py-3 mt-3 reimbursement-fee__activator"
        v-if="reimbursement.status === $constants.REIMBURSEMENT_ORDER_STATUS.CONFIRM"
      >
        <v-list-tile :title="$t('fee.reim.refund_additional_fees')">
          <v-list-tile-action>
            <img
              width="24"
              height="24"
              src="/assets/images/icons/WaterBill.svg"
              v-img-fallback-text="$t('fee.reim.refund_additional_fees')"
            />
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title class="mb-2" :class="{ 'body-1': isMobile }">{{
              $t('fee.reim.title')
            }}</v-list-tile-title>
            <v-list-tile-sub-title>
              <v-btn
                depressed
                color="accent"
                data-test-id="SHOW-REIM-MODAL-BTN"
                class="px-3 py-2 ma-0 text-none"
                v-on="on"
                >{{ $t('fee.reim.pay_now') }}</v-btn
              >
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-card>
      <template v-else>
        <v-divider class="my-1"> </v-divider>
        <v-list-tile class="reimbursement-fee__mobile">
          <v-list-tile-action>
            <img
              width="24"
              height="24"
              src="/assets/images/icons/WaterBill.svg"
              v-img-fallback-text="
                $t(
                  reimbursement.status === $constants.REIMBURSEMENT_ORDER_STATUS.PAID
                    ? 'fee.reim.additional_fees'
                    : 'fee.reim.refund_additional_fees'
                )
              "
            />
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-sub-title class="subheading font-weight-medium">{{
              $t(
                reimbursement.status === $constants.REIMBURSEMENT_ORDER_STATUS.PAID
                  ? 'fee.reim.additional_fees'
                  : 'fee.reim.refund_additional_fees'
              )
            }}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn
              flat
              small
              class="pl-2 text-none"
              v-on="on"
              v-if="reimbursement.status === $constants.REIMBURSEMENT_ORDER_STATUS.PAID"
            >
              <vue-numeric
                :currency="currency"
                :value="reimbursement.total_fee"
                read-only
                name="reimbursement_total_fee"
              ></vue-numeric>
              <v-icon color="grey">chevron_right</v-icon>
            </v-btn>
            <v-btn flat icon v-on="on" v-else>
              <v-icon color="grey">chevron_right</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </template>
    </template>
    <v-card>
      <v-toolbar :color="isMobile ? '#142246' : 'white'" :class="{ 'white--text': isMobile }">
        <v-btn icon @click="closeModal" v-if="isMobile">
          <v-icon color="white">close</v-icon>
        </v-btn>
        <v-toolbar-title :class="{ 'flex grow ml-0 pr-4 text-xs-center': isMobile }">
          {{
            $t(
              reimbursement.status === $constants.REIMBURSEMENT_ORDER_STATUS.PAID
                ? 'fee.reim.additional_fees'
                : 'fee.reim.refund_additional_fees'
            )
          }}
        </v-toolbar-title>
        <template v-if="!isMobile">
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
        </template>
      </v-toolbar>

      <v-card-text class="pa-3" :style="{ height: '100%' }">
        <p class="body-1 grey--text text--darken-3">{{ $t('fee.reim.description') }}</p>
        <v-card
          flat
          v-for="(request, index) in [...reimbursement.requests]"
          :key="index"
          class="reimbursement-fee__request"
        >
          <v-toolbar card height="52">
            <v-layout align-center row class="body-2">
              <v-flex grow>
                <span>{{ request[`name${localeSuffix}`] }}</span>
                <div
                  class="d-inline-block ml-1"
                  :style="{ 'vertical-align': 'text-top' }"
                  v-if="isMobile"
                  @click="showToolTip(request[`description${localeSuffix}`])"
                >
                  <SvgIcon icon="InfoOutline" width="15" height="15" />
                </div>

                <v-tooltip v-else right class="ml-1" content-class="v-tooltip__custom-content">
                  <SvgIcon icon="InfoOutline" width="15" height="15" slot="activator" />
                  <span>{{ request[`description${localeSuffix}`] }}</span>
                </v-tooltip>
              </v-flex>
              <v-flex shrink>
                <vue-numeric
                  :currency="currency"
                  :value="request.amount"
                  read-only
                  :name="request.id"
                ></vue-numeric>
              </v-flex>
            </v-layout>
          </v-toolbar>
          <v-divider></v-divider>

          <v-card-text>
            <v-list class="py-0">
              <v-list-tile v-if="request.start_time" class="mb-2">
                <v-list-tile-content>
                  <v-list-tile-sub-title class="mb-1">{{
                    $t('fee.reim.start_time')
                  }}</v-list-tile-sub-title>
                  <v-list-tile-title class="body-2">{{
                    $moment.unix(request.start_time).format('ddd, DD/MM HH:mm')
                  }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="request.end_time" class="mb-2">
                <v-list-tile-content>
                  <v-list-tile-sub-title class="mb-1">{{
                    $t('fee.reim.end_time')
                  }}</v-list-tile-sub-title>
                  <v-list-tile-title class="body-2">{{
                    $moment.unix(request.end_time).format('ddd, DD/MM HH:mm')
                  }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="request.types">
                <v-list-tile-content>
                  <v-list-tile-sub-title class="mb-2">{{
                    $t('fee.reim.service_detail')
                  }}</v-list-tile-sub-title>
                  <v-list-tile-title
                    class="body-2"
                    v-for="(type, index) in request.types"
                    :key="index"
                    >{{ type[`name${localeSuffix}`] }}</v-list-tile-title
                  >
                </v-list-tile-content>
              </v-list-tile>
              <v-divider
                v-if="request.start_time || request.end_time || request.types"
                class="my-3"
              ></v-divider>

              <v-list-tile v-if="request.image_urls">
                <v-list-tile-content>
                  <v-list-tile-sub-title class="mb-2">{{
                    $t('fee.reim.verified_images')
                  }}</v-list-tile-sub-title>
                  <v-layout row wrap align-start>
                    <figure
                      v-for="(image, index) in request.image_urls"
                      :key="index"
                      class="mb-1 mr-1 cursor-pointer"
                      @click="viewImage(image)"
                    >
                      <v-img
                        :aspect-ratio="1"
                        width="56"
                        height="56"
                        contain
                        :src="image"
                        class="grey lighten-1"
                        data-test-id="REVIEW-IMG"
                      />
                    </figure>
                  </v-layout>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-card-text>

      <v-divider v-if="!isMobile"></v-divider>

      <v-card-actions class="elevation-16 pa-3">
        <v-layout column>
          <v-layout align-center row class="reimbursement-fee__total">
            <v-flex grow class="body-1">{{ $t('fee.reim.grand_total') }}</v-flex>
            <v-flex shrink class="headline font-weight-medium text-primary">
              <vue-numeric
                :currency="currency"
                :value="reimbursement.total_fee"
                read-only
                name="reimbursement_total_fee"
              ></vue-numeric>
            </v-flex>
          </v-layout>
          <v-layout
            align-center
            row
            class="reimbursement-fee__total"
            mt-2
            v-if="
              paymentMethod && reimbursement.status === $constants.REIMBURSEMENT_ORDER_STATUS.PAID
            "
          >
            <v-flex grow class="body-1">
              {{ $t('payment_method.title') }}
            </v-flex>
            <v-flex shrink class="body-2 d-flex align-center" v-if="paymentMethodAssets">
              <img :src="paymentMethodAssets.icon" width="16" />
              <span class="ml-2">{{ paymentMethodAssets.name }}</span>
            </v-flex>
          </v-layout>
          <v-layout
            row
            mt-3
            v-if="reimbursement.status === $constants.REIMBURSEMENT_ORDER_STATUS.CONFIRM"
          >
            <v-btn
              @click="goToCheckoutPage"
              block
              large
              depressed
              color="accent"
              data-test-id="SELECT-BTN"
              class="text-none"
            >
              {{ $t('continue') }}
            </v-btn>
          </v-layout>
        </v-layout>
      </v-card-actions>
    </v-card>
    <ViewImageModal ref="viewImageModal" :img-src="selectedImage" />
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ViewImageModal from '@/components/ViewImageModal'
import { getPaymentMethodAssets } from '@/plugins/util'

export default {
  name: 'ReimbursementFeeModal',
  components: {
    ViewImageModal
  },
  props: {
    orderId: {
      type: String
    },
    reimbursement: {
      type: Object,
      default: () => {}
    },
    currency: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      selectedImage: undefined
    }
  },
  computed: {
    ...mapGetters(['localeSuffix']),
    paymentMethod() {
      return this.reimbursement && this.reimbursement.payment_method
    },
    paymentMethodAssets() {
      return this.paymentMethod && getPaymentMethodAssets(this.paymentMethod)
    }
  },
  methods: {
    closeModal() {
      this.visible = false
    },
    viewImage(image) {
      this.selectedImage = image
      this.$refs.viewImageModal.showModal = true
    },
    goToCheckoutPage() {
      this.$router.push({
        name: 'checkout',
        params: {
          id: this.orderId
        },
        query: { ...this.$route.query, payment_type: this.$constants.PAYMENT_TYPE.REIMBURSEMENT }
      })
    },
    showToolTip(title) {
      this.$store.dispatch('setSnackbar', {
        visible: true,
        title,
        timeout: 1500
      })
    }
  }
}
</script>

<style lang="scss">
.reimbursement-fee {
  > .v-card {
    > .v-toolbar {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      z-index: 10;
    }

    .v-card__actions {
      z-index: 1;
    }
  }

  &__activator {
    margin-bottom: -16px;

    .v-list__tile {
      min-height: 48px;
      height: auto;
      align-items: flex-start;

      &__title {
        height: auto;
        white-space: normal;
        overflow: visible;
      }

      &__action {
        min-width: 40px;
        margin: 12px 0;
      }
    }

    .v-btn {
      height: 40px;
      line-height: 40px;
    }
  }

  &__mobile {
    margin-bottom: -24px;

    .v-list__tile {
      padding: 8px 0 0;
      height: auto;

      &__action {
        min-width: 40px;
      }
    }
  }

  &__total {
    color: #4d5358;

    &_price {
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      color: #ff8200;
    }
  }

  &__request {
    border: 1px solid #dde1e6 !important;
    border-radius: 8px;

    + .reimbursement-fee__request {
      margin-top: 16px;
    }

    .v-toolbar {
      background: rgba(242, 244, 248, 0.5);

      &__content {
        padding: 0 16px;
      }
    }

    .v-tooltip {
      cursor: pointer;
      vertical-align: text-bottom;
      display: inline-block;
    }

    .v-list__tile {
      height: auto;
      padding: 0;
    }
  }

  &.isMobile {
    .reimbursement-fee {
      &__activator {
        .v-btn {
          height: 36px;
          line-height: 36px;
        }
      }
    }
  }
}
</style>
